import { NgModule } from "@angular/core";
import { AiGeneralSummaryModalComponent } from "./ai-general-summary-modal.component";
import { GeneralValuationTableComponent } from "./general-valuation-table/general-valuation-table.component";
import { GeneralValuationFinalConceptsTableComponent } from "./general-valuation-final-concepts-table/general-valuation-final-concepts-table.component";
import { ManagementLeadershipTableComponent } from "./management-leadership-table/management-leadership-table.component";
import { AiTagsSummaryChartComponent } from "./ai-tags-summary-chart/ai-tags-summary-chart.component";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { PipesModule } from "../../pipes/pipes.module";
import { TagCommentsSummaryComponent } from "./ai-tags-summary-chart/tag-comments-summary/tag-comments-summary.component";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { QualitativeEvaluationModule } from "src/app/calibration/components/user-overview/qualitative-evaluation/qualitative-evaluation.module";
import { AiSummaryContentComponent } from "./ai-summary-content/ai-summary-content.component";
import { AiManagementEvaluationService } from "../ai-management-evaluation/ai-management-evaluation.service";


@NgModule({
    declarations: [
        AiGeneralSummaryModalComponent,
        GeneralValuationTableComponent,
        GeneralValuationFinalConceptsTableComponent,
        ManagementLeadershipTableComponent,
        AiTagsSummaryChartComponent,
        TagCommentsSummaryComponent,
        AiSummaryContentComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
        MatTooltipModule,
        QualitativeEvaluationModule
    ],
    exports: [
        AiGeneralSummaryModalComponent,
        GeneralValuationTableComponent,
        GeneralValuationFinalConceptsTableComponent,
        ManagementLeadershipTableComponent,
        AiTagsSummaryChartComponent,
        AiSummaryContentComponent
    ],
    providers: [AiManagementEvaluationService]
})
export class AiGeneralSummaryModalModule { }
